var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{ref:"sidebarMenu",staticClass:"Sidebar-container",attrs:{"background-color":"#0A64FE","text-color":"#fff","active-text-color":"#fff","default-active":_vm.defaultPath,"collapse":_vm.collapse},on:{"select":_vm.select_menu}},[_c('sidebar-item',{attrs:{"routes":_vm.menuList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22394b19","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components_v3/layout/left-sider/left-sider.vue
// module id = null
// module chunks = 